import { motion } from "framer-motion";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { ArticleTable } from "@/components/admin/content/ArticleTable";
import { DeepDiveList } from "@/components/admin/content/DeepDiveList";
import { SourceGrid } from "@/components/admin/content/SourceGrid";

export default function Content() {
  return (
    <div className="space-y-6">
      <motion.div initial={{ opacity: 0, y: -10 }} animate={{ opacity: 1, y: 0 }}>
        <h1 className="text-3xl font-semibold tracking-tight">Content</h1>
        <p className="text-muted-foreground mt-1">
          Manage articles, deep dives, and RSS sources.
        </p>
      </motion.div>

      <Tabs defaultValue="articles" className="space-y-6">
        <TabsList className="bg-secondary/50">
          <TabsTrigger value="articles">Articles</TabsTrigger>
          <TabsTrigger value="deep-dives">Deep Dives</TabsTrigger>
          <TabsTrigger value="sources">RSS Sources</TabsTrigger>
        </TabsList>

        <TabsContent value="articles"><ArticleTable /></TabsContent>
        <TabsContent value="deep-dives"><DeepDiveList /></TabsContent>
        <TabsContent value="sources"><SourceGrid /></TabsContent>
      </Tabs>
    </div>
  );
}
